import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('roles', [
    'GET_ALL',
    'UPDATE',
    'CREATE',
    'DELETE',
    'SET_FILTERS'
]);
export const initialRolesState = {
    ...generateDefaultState('roles', [
        'GET_ALL',
        'UPDATE',
        'CREATE',
        'DELETE',
        'SET_FILTERS'
    ]),
};
